import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import { IonicVue } from "@ionic/vue";

import "@ionic/core/css/core.css";
import "@ionic/core/css/ionic.bundle.css";

import "@/assets/tailwind.css";

import "./registerServiceWorker";

const app = createApp(App);
app.use(IonicVue, {
  mode: "md",
});
app.use(router);
app.use(store);
app.mount("#app");
